import React from 'react';
import { ArrowRightIcon, AwardIcon, StarIcon } from 'lucide-react';
export function FeaturedRecognitionSection() {
  return <section className="py-32 bg-[#020202] relative overflow-hidden border-y border-white/5" data-id="element-81" data-mp="3t1ls7fsksnfk">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60rem] h-[30rem] bg-[#D4AF37]/5 rounded-[100%] blur-[120px] pointer-events-none" data-id="element-82" data-mp="3o7hlmxn82hf0" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-83" data-mp="3f9ns1ugue1vj">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-84" data-mp="3a99vb8koyect">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 mb-6" data-id="element-85" data-mp="3abw235zrcptz">
            <AwardIcon className="w-4 h-4 text-[#D4AF37]" data-id="element-86" data-mp="30bvdp5n17jix" />
            <span className="text-xs font-bold text-gray-300 uppercase tracking-widest" data-id="element-87" data-mp="30dg88v9cj2gs">
              Industry Recognition
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight" data-id="element-88" data-mp="yk0hlyd9dnlt">
            Recognized by the best in the Shopify ecosystem.
          </h2>
          <p className="text-xl text-gray-400" data-id="element-89" data-mp="399g64zhijunh">
            Our commitment to engineering excellence and conversion-driven
            design has earned us features from leading ecommerce platforms.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-90" data-mp="3480hyyk1h80v">
          {/* Omnisend Feature */}
          <a href="https://www.omnisend.com/blog/shopify-experts/" target="_blank" rel="noopener noreferrer" className="group relative rounded-3xl bg-white/[0.02] border border-white/10 p-10 hover:bg-white/[0.04] hover:border-white/20 transition-all duration-500 overflow-hidden flex flex-col h-full" data-id="element-91" data-mp="3rxl1pjo0o9b7">
            <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/10 rounded-full blur-[80px] opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-92" data-mp="3n4rzp3jxnf2t" />

            <div className="mb-8" data-id="element-93" data-mp="jjvzmgp7nf8o">
              <img src="https://cdn.magicpatterns.com/uploads/tEKY1KVFn8NPQae4HonbJW/omnisend-logo.png" alt="Omnisend" className="h-8 object-contain opacity-70 group-hover:opacity-100 transition-opacity" onError={e => {
              // Fallback if logo fails
              e.currentTarget.style.display = 'none';
              e.currentTarget.nextElementSibling?.classList.remove('hidden');
            }} data-id="element-94" data-mp="tejo0zy167qm" />
              <span className="hidden text-2xl font-bold text-white tracking-tight" data-id="element-95" data-mp="5o77x1smt4oy">
                Omnisend
              </span>
            </div>

            <h3 className="text-2xl font-bold text-white mb-4 leading-snug" data-id="element-96" data-mp="n9ratn9sipk">
              "Top Shopify Experts for Ecommerce Development"
            </h3>

            <p className="text-gray-400 text-lg mb-10 flex-grow leading-relaxed" data-id="element-97" data-mp="3nubwnfdojbip">
              Recognized among the industry's elite Shopify experts for
              exceptional store development, custom design, and technical
              expertise.
            </p>

            <div className="flex items-center gap-2 text-emerald-400 font-semibold mt-auto" data-id="element-98" data-mp="23brj7n03ws5i">
              Read the feature{' '}
              <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-99" data-mp="28c5tlbp6ke6p" />
            </div>
          </a>

          {/* EComposer Feature */}
          <a href="https://ecomposer.io/blogs/ecommerce/best-shopify-web-designers" target="_blank" rel="noopener noreferrer" className="group relative rounded-3xl bg-white/[0.02] border border-white/10 p-10 hover:bg-white/[0.04] hover:border-white/20 transition-all duration-500 overflow-hidden flex flex-col h-full" data-id="element-100" data-mp="1fmf9mm0vai2o">
            <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/10 rounded-full blur-[80px] opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-101" data-mp="1tfy724qav0o9" />

            <div className="mb-8" data-id="element-102" data-mp="10vg79sqmkprj">
              <img src="https://cdn.magicpatterns.com/uploads/tEKY1KVFn8NPQae4HonbJW/ecomposer-logo.png" alt="EComposer" className="h-8 object-contain opacity-70 group-hover:opacity-100 transition-opacity" onError={e => {
              e.currentTarget.style.display = 'none';
              e.currentTarget.nextElementSibling?.classList.remove('hidden');
            }} data-id="element-103" data-mp="hso3j53nyoyz" />
              <span className="hidden text-2xl font-bold text-white tracking-tight" data-id="element-104" data-mp="10hkrkr8gwl8r">
                EComposer
              </span>
            </div>

            <h3 className="text-2xl font-bold text-white mb-4 leading-snug" data-id="element-105" data-mp="1ahv2u6axzila">
              "Best Shopify Web Designers"
            </h3>

            <p className="text-gray-400 text-lg mb-10 flex-grow leading-relaxed" data-id="element-106" data-mp="15j1rajf7u1nr">
              Listed among the best Shopify web designers globally for creating
              high-converting, beautifully engineered storefronts.
            </p>

            <div className="flex items-center gap-2 text-blue-400 font-semibold mt-auto" data-id="element-107" data-mp="1ms2x7cfdt3jx">
              Read the feature{' '}
              <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-108" data-mp="1rpw11yt7plh1" />
            </div>
          </a>
        </div>
      </div>
    </section>;
}